/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Material } from 'src/app/_model/material';

@Injectable()
export abstract class MaterialsDaoService implements Resetable {
  public abstract setLastSyncTstamp(
     tstamp: number
  ): Promise<void>;
  public abstract getLastSyncTstamp(): Promise<number>;
  public abstract saveMaterials(materials: Material[]): Promise<void>;
  public abstract getMaterials(): Promise<Material[]>;
  public abstract deleteMaterials(ids: number[]): Promise<void>;
  public abstract saveMaterialsOnTheMove(ids: number[]): Promise<void>;
  public abstract removeMaterialsOnTheMove(): Promise<void>;
  public abstract getMaterialsOnTheMove(): Promise<number[]>;
  public abstract saveMaterialsTranslateObject(translateObject: any): Promise<void>;
  public abstract getMaterialsTranslateObject(): Promise<any>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
